export class Users {
    id_user: number;
    login_user: string;
    mot_de_pass: string;
    type_id: number;
    perd_id: number;
    etat: string ="A";
    pers_info :string;
    matricule:any;
    sigle_user:any;
    dir_user:any;

    constructor(id_user: number) { }
}

